declare const history: any;
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Ladder } from 'src/models/ladder.model';
import { Match } from 'src/models/match.model';
import { Pairing } from 'src/models/pairing.model';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { RecordService } from './record.service';
import { DateTime } from 'luxon';

export abstract class RecordMatchBaseComponent {
  public DateTime: any = DateTime;
  public possibleScores: number[] = [...Array(8).keys()];
  public possibleTieScores: number[] = [...Array(21).keys()];
  private validScores: string[][] = [['7', '6'], ['7', '5'], ['6', '4'], ['6', '3'], ['6', '2'], ['6', '1'], ['6', '0']];
  public player: Player = new Player();
  public pairings: Pairing[] = [];
  public busy: boolean = false;
  public busySave: boolean = false;
  public ladderOver: boolean = false;
  public matchForm: FormGroup;
  public round: number;
  public ladderInfo: Ladder;

  constructor(protected recordSvc: RecordService, protected userSvc: UserService, protected http: HttpClient,
    private fb: FormBuilder, public router: Router) {
    this.busy = true;

    this.matchForm = this.fb.group({
      opponentId: new FormControl(null),  //number
      pairingId: new FormControl(),
      Set1Player1Score: new FormControl('0'),
      Set1Player2Score: new FormControl('0'),
      Set2Player1Score: new FormControl('0'),
      Set2Player2Score: new FormControl('0'),
      Set3Player1Score: new FormControl('0'),
      Set3Player2Score: new FormControl('0'),

      Set1Player1Tie: new FormControl('0'),
      Set1Player2Tie: new FormControl('0'),
      Set2Player1Tie: new FormControl('0'),
      Set2Player2Tie: new FormControl('0'),
      Set3Player1Tie: new FormControl('0'),
      Set3Player2Tie: new FormControl('0')
    });
    // on change of opponents, show the user what round they are recording
    this.matchForm.controls.opponentId.valueChanges.subscribe((opponentId) => {
      let o = this.pairings.find(o => o.pairingPlayer.id == opponentId);
      this.matchForm.controls.pairingId.setValue(o.pairingId);
      this.round = o.round;
    });

  }

  public abstract saveForfeitWorker();
  public saveForfeit(evt: any) {
    evt.preventDefault();
    if (this.busySave) return;
    if (this.matchForm.value.pairingId == undefined || this.matchForm.value.pairingId == null || this.matchForm.value.pairingId == 0) {
      alert('You must select an opponent.');
      return;
    }

    const opponentId = this.matchForm.value.opponentId;
    const p = this.pairings.find(p => p.pairingPlayer.id == opponentId);


    if (confirm(`Are you sure ${p.pairingPlayer.name} forfeited the match and you win?`)) {
      this.saveForfeitWorker();
    }
  }

  public abstract saveRetiredWorker();
  public saveRetired(evt: any) {
    evt.preventDefault();
    if (this.busySave) return;
    if (this.matchForm.value.pairingId == undefined || this.matchForm.value.pairingId == null || this.matchForm.value.pairingId == 0) {
      alert('You must select an opponent.');
      return;
    }

    const opponentId = this.matchForm.value.opponentId;
    const p = this.pairings.find(p => p.pairingPlayer.id == opponentId);

    if (confirm(`Are you sure ${p.pairingPlayer.name} retired and you win?`)) {
      this.saveRetiredWorker();
    }
  }

  // TODO more checking
  public canSave(): boolean {
    const values = this.matchForm.value;
    if (values.opponentId == null) return false;
    if (!this.validSetScore([values.Set1Player1Score, values.Set1Player2Score])) return false;
    if (!this.validSetScore([values.Set2Player1Score, values.Set2Player2Score])) return false;
    // if user picked any value for set 3, make sure they are at least valid
    if (values.Set3Player1Score > 0 || values.Set3Player2Score > 0) {
      if (!this.validSetScore([values.Set3Player1Score, values.Set3Player2Score])
        && !this.valid3rdSetScore([values.Set3Player1Score, values.Set3Player2Score])) return false;
    }
    return true;
  }

  // public canForfeit(): boolean {
  //   const values = this.matchForm.value;
  //   if (values.opponentId == null) return false;
  //   return true;
  // }

  private validSetScore(score): boolean {
    if (score[0] < score[1]) score.reverse();
    if (this.validScores.some(x => x.join() == score.join())) return true;
    else return false;
  }

  private valid3rdSetScore(score): boolean {
    return score.join() == '0,0';
  }

}
